import { useState, type FC, type PropsWithChildren } from 'react';

import {
  CircuitDispatchContext,
  CircuitStateContext,
  initialState,
} from './context.js';
import type { ApprovalProcessStateContext } from './types.js';

export const ApprovalProcessProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const [state, setState] = useState<ApprovalProcessStateContext>(initialState);

  return (
    <CircuitStateContext value={state}>
      <CircuitDispatchContext value={setState}>
        {children}
      </CircuitDispatchContext>
    </CircuitStateContext>
  );
};
